import { BasicQueryStringUtils } from '@openid/appauth';

export class NoHashQueryStringUtils extends BasicQueryStringUtils {
    parse(input) {
        return super.parse(input, false);
    }
}
